import { useEffect } from "react";
import { useShownColorScheme } from "hooks/useShownColorScheme";
import { Polyline } from "leaflet";
import L from "leaflet";
import "./TooltipColors.css";

type Props = {
  polyline: Polyline;
  html: string;
  maxWidth?: number;
};

export const CustomTooltip = ({ polyline, html }: Props) => {
  const colorScheme = useShownColorScheme();

  useEffect(() => {
    const tooltip = L.tooltip({
      direction: "top",
      opacity: 1,
      permanent: true,
      interactive: true,
      className:
        colorScheme === "dark"
          ? "trkbk-map-dark-tooltip"
          : "trkbk-map-light-tooltip",
    });

    tooltip.setContent(html);
    polyline.bindTooltip(tooltip);

    return () => {
      if (polyline && tooltip) {
        try {
          polyline.unbindTooltip();
          // Based on the source code I'm not sure this can even throw so the try/catch could be useless here
        } catch (_error) {
          // ignore if polyline is not binded anymore or other errors from the method
        }
      }
    };
  }, [html, polyline, colorScheme]);

  return null;
};
